/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LaptopProvider {
  None = "None",
  Client = "Client",
  Axiom = "Axiom",
}

export const LaptopProviderDisplay: Record<LaptopProvider, string> = {
  [LaptopProvider.None]: "None",
  [LaptopProvider.Client]: "Client",
  [LaptopProvider.Axiom]: "Axiom",
};
